import React, { useState, useRef, useEffect } from "react";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { 
      text: "Bonjour ! 👋 Bienvenue chez DOMOELEC. Notre équipe vous répondra rapidement ! ⚡", 
      isBot: true,
      timestamp: new Date()
    }
  ]);
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (inputMessage.trim()) {
      const newMessage = { 
        text: inputMessage, 
        isBot: false, 
        timestamp: new Date() 
      };
      setMessages(prev => [...prev, newMessage]);
      
      // Préparer le message pour WhatsApp
      const whatsappMessage = `Bonjour, je contacte DOMOELEC depuis le site web.

Message: ${inputMessage}

Merci pour votre attention.`;
      
      // Encoder le message pour l'URL
      const encodedMessage = encodeURIComponent(whatsappMessage);
      
      // Créer le lien WhatsApp
      const whatsappUrl = `https://wa.me/212661301243?text=${encodedMessage}`;
      
      // Ouvrir WhatsApp dans un nouvel onglet
      window.open(whatsappUrl, '_blank');
      
      // Message de confirmation
      setTimeout(() => {
        setMessages(prev => [...prev, { 
          text: "✅ Votre message a été envoyé vers WhatsApp ! Notre équipe vous répondra rapidement. 📱", 
          isBot: true,
          timestamp: new Date()
        }]);
      }, 500);
      
      setInputMessage("");
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('fr-FR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <>
      <button
        type="button"
        className="chatbot-toggle"
        onClick={toggleChatbot}
        aria-label="Ouvrir le chat WhatsApp"
      >
        <span className="chatbot-toggle__ping" aria-hidden="true"></span>
        <span className="chatbot-toggle__pulse" aria-hidden="true"></span>
        <svg
          className="chatbot-toggle__icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fill="#ffffff"
            d="M19.11 17.2c-.29-.15-1.71-.84-1.97-.94-.27-.1-.46-.15-.66.15-.19.29-.76.94-.93 1.13-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.32-1.43-.86-.77-1.43-1.71-1.6-2-.17-.29-.02-.45.13-.59.13-.13.29-.34.44-.51.15-.17.19-.29.29-.49.1-.19.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5-.17-.01-.36-.01-.56-.01-.19 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.19 3.02.15.19 2.05 3.13 4.97 4.39.69.3 1.24.48 1.66.61.7.22 1.33.19 1.84.12.56-.08 1.71-.7 1.95-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.19-.56-.34z"
          />
          <path
            fill="#ffffff"
            d="M26.88 5.12C24 2.25 20.17.67 16.1.67 7.71.67.9 7.48.9 15.87c0 2.68.7 5.3 2.03 7.61L.77 31.33l8.03-2.11c2.22 1.21 4.72 1.85 7.29 1.85h.01c8.39 0 15.2-6.82 15.2-15.2 0-4.06-1.59-7.88-4.42-10.75zM16.1 28.51h-.01c-2.29 0-4.53-.62-6.48-1.78l-.46-.28-4.77 1.25 1.27-4.64-.3-.48c-1.28-2.03-1.95-4.37-1.95-6.71 0-7 5.7-12.69 12.7-12.69 3.39 0 6.57 1.32 8.97 3.72 2.4 2.4 3.72 5.59 3.72 8.97 0 7-5.69 12.69-12.69 12.69z"
          />
        </svg>
      </button>
      
      {isOpen && (
        <div 
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '20px',
            width: '350px',
            height: '500px',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1001,
            overflow: 'hidden'
          }}
        >
          {/* Header WhatsApp Style */}
          <div 
            style={{
              background: '#075E54',
              color: 'white',
              padding: '16px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div 
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px'
                }}
              >
                <img 
                  src="/images/whats.png" 
                  alt="DOMOELEC" 
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '16px' }}>DOMOELEC Support</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>En ligne</div>
              </div>
            </div>
            <button 
              onClick={toggleChatbot}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '4px'
              }}
            >
              ✕
            </button>
          </div>

          {/* Messages Area */}
          <div 
            style={{
              flex: 1,
              padding: '16px',
              background: '#ECE5DD',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}
          >
            {messages.map((message, index) => (
              <div 
                key={index} 
                style={{
                  display: 'flex',
                  justifyContent: message.isBot ? 'flex-start' : 'flex-end',
                  marginBottom: '8px'
                }}
              >
                <div 
                  style={{
                    maxWidth: '80%',
                    padding: '10px 16px',
                    borderRadius: message.isBot ? '18px 18px 18px 4px' : '18px 18px 4px 18px',
                    background: message.isBot ? 'white' : '#DCF8C6',
                    color: '#333',
                    fontSize: '14px',
                    lineHeight: '1.4',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                    position: 'relative'
                  }}
                >
                  <div>{message.text}</div>
                  <div 
                    style={{
                      fontSize: '11px',
                      color: '#999',
                      marginTop: '4px',
                      textAlign: 'right'
                    }}
                  >
                    {formatTime(message.timestamp)}
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Area */}
          <div 
            style={{
              padding: '16px',
              background: 'white',
              borderTop: '1px solid #e0e0e0'
            }}
          >
            <form onSubmit={sendMessage} style={{ display: 'flex', gap: '8px' }}>
              <input 
                type="text" 
                placeholder="Tapez votre message..." 
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '25px',
                  outline: 'none',
                  fontSize: '14px'
                }}
              />
              <button 
                type="submit"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#25D366',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px'
                }}
              >
                ➤
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
